"use client";
import { create } from "zustand";

export const useTheme = create((set) => ({ theme: "", setTheme: (theme) => set({ theme }) }));

export const useStore = create((set) => ({
  loading: false,
  setLoading: (loading) => set({ loading }),
  token: {},
  setToken: (token) => set({ token }),
  cldImageData: [],
  setCldImageData: (cldImageData) => set({ cldImageData }),
}));
